webpackJsonp([3],{

/***/ 100:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NotificationCenter__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_solid__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_font_loaded__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_font_loaded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_font_loaded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_js_zendesk__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_js_zendesk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_js_zendesk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_js_sessionContext_js__ = __webpack_require__(44);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














__webpack_require__(18);
__webpack_require__(63);

var fontLoaded = new __WEBPACK_IMPORTED_MODULE_6_font_loaded___default.a('Lato');

fontLoaded.on('load', function (fontName) {
  window.dispatchEvent(new Event('resize'));
});

fontLoaded.on('error', function (fontName) {
  window.dispatchEvent(new Event('resize'));
});

__WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome__["default"].library.add(__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_solid__["a" /* default */]);
var clickoutside = {
  inserted: function inserted(el, binding, vnode) {
    function documentHandler(e) {
      if (document.getElementById('titanNavigation').style.display !== undefined && document.getElementById('titanNavigation').style.display === 'none') {
        return false;
      }
      if (document.getElementById('tnLeftMenu').contains(e.target)) {
        return false;
      }

      if (binding.expression) {
        binding.value();
      }
    }

    el.__vueClickOutside__ = documentHandler;
    document.addEventListener('click', documentHandler);
  },
  update: function update() {},
  unbind: function unbind(el, binding) {
    document.removeEventListener('click', el.__vueClickOutside__);
    delete el.__vueClickOutside__;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'neon-header',
  data: function data() {
    return {
      searchResults: [],
      userContext: __WEBPACK_IMPORTED_MODULE_12__assets_js_sessionContext_js__["a" /* default */].getUserContext(),
      clientWidth: document.body.clientWidth,
      firstMenuWidth: 0,
      menus: [{
        id: 1,
        module: 'dashboard',
        displayName: 'Dashboard',
        isActive: false,
        show: true,
        width: 0,
        subMenu: {
          menuLeftAlign: true,
          iconMenuTitle: 'Dashboard menu panel',
          iconMenus: [{
            id: 1,
            displayName: 'Mission Control',
            url: 'https://www.google.com',
            iconName: 'fas fa-rocket'
          }, {
            id: 2,
            displayName: 'Accounts',
            url: 'https://www.google.com',
            iconName: 'fas fa-user'
          }, {
            id: 3,
            displayName: 'Communications',
            url: 'https://www.google.com',
            iconName: 'fas fa-bullhorn'
          }, {
            id: 4,
            displayName: 'Events',
            url: 'https://www.google.com',
            iconName: 'fas fa-calendar'
          }, {
            id: 5,
            displayName: 'Fundraising',
            url: 'https://www.google.com',
            iconName: 'fas fa-piggy-bank'
          }, {
            id: 6,
            displayName: 'Membership',
            url: 'https://www.google.com',
            iconName: 'fas fa-id-card'
          }, {
            id: 7,
            displayName: 'Reports',
            url: 'https://www.google.com',
            iconName: 'fas fa-chart-line'
          }, {
            id: 8,
            displayName: 'Store',
            url: 'https://www.google.com',
            iconName: 'fas fa-shopping-cart'
          }]
        }
      }, {
        id: 2,
        module: 'accounts',
        displayName: 'Accounts',
        isActive: false,
        show: true,
        width: 0,
        subMenu: {
          menuLeftAlign: true,
          iconMenuTitle: 'Account menu panel',
          iconMenus: [{
            id: 1,
            displayName: 'Accounts',
            url: 'https://www.google.com',
            iconName: 'fas fa-user'
          }, {
            id: 2,
            displayName: 'Households',
            url: 'https://www.google.com',
            iconName: 'fas fa-home'
          }]
        }
      }, {
        id: 3,
        module: 'fundraising',
        displayName: 'Fundraising',
        isActive: false,
        show: true,
        width: 0,
        subMenu: {
          menuLeftAlign: true,
          iconMenuTitle: 'Fundraising menu panel',
          iconMenus: [{
            id: 1,
            displayName: 'Donations & Pledges',
            url: 'https://www.google.com',
            iconName: 'fas fa-hand-holding-heart'
          }, {
            id: 2,
            displayName: 'Tributes',
            url: 'https://www.google.com',
            iconName: 'fas fa-ribbon'
          }, {
            id: 3,
            displayName: 'Recurring Donation Schedules',
            url: 'https://www.google.com',
            iconName: 'fas fa-user-clock'
          }, {
            id: 4,
            displayName: 'Fundraising Campaign',
            url: 'https://www.google.com',
            iconName: 'fas fa-bullhorn'
          }, {
            id: 5,
            displayName: 'Social Fundraising Campaigns',
            url: 'https://www.google.com',
            iconName: 'fas fa-user-friends'
          }, {
            id: 6,
            displayName: 'Batch Donation Entry',
            url: 'https://www.google.com',
            iconName: 'fas fa-table'
          }]
        }
      }, {
        id: 4,
        module: 'members',
        displayName: 'Members',
        isActive: false,
        show: true,
        width: 0,
        subMenu: {
          menuLeftAlign: true,
          iconMenuTitle: 'Member menu panel',
          iconMenus: [{
            id: 1,
            displayName: 'New Individual Member',
            url: 'https://www.google.com',
            iconName: 'fas fa-id-card'
          }, {
            id: 2,
            displayName: 'New Organization Member',
            url: 'https://www.google.com',
            iconName: 'fas fa-building'
          }]
        }
      }, {
        id: 5,
        module: 'Events',
        displayName: 'Events',
        isActive: false,
        show: true,
        width: 0
      }, {
        id: 6,
        module: 'reports',
        displayName: 'Reports',
        isActive: false,
        show: true,
        width: 0,
        subMenu: {
          menuLeftAlign: true,
          iconMenuTitle: 'Report menu panel',
          iconMenus: [{
            id: 1,
            displayName: 'New Report',
            url: 'https://www.google.com',
            iconName: 'fas fa-plus'
          }, {
            id: 2,
            displayName: 'One-click Report',
            url: 'https://www.google.com',
            iconName: 'fas fa-hand-point-up'
          }, {
            id: 3,
            displayName: 'Executive Reports',
            url: 'https://www.google.com',
            iconName: 'fas fa-trophy'
          }, {
            id: 4,
            displayName: 'Saved Reports',
            url: 'https://www.google.com',
            iconName: 'fas fa-save'
          }, {
            id: 5,
            displayName: 'Auto Reports',
            url: 'https://www.google.com',
            iconName: 'fas fa-magic'
          }]
        }
      }, {
        id: 7,
        module: 'emails',
        displayName: 'Emails',
        isActive: false,
        show: true,
        width: 0,
        subMenu: {
          menuLeftAlign: true,
          iconMenuTitle: 'Email menu panel',
          iconMenus: [{
            id: 1,
            displayName: 'Email Audiences',
            url: 'https://www.google.com',
            iconName: 'fas fa-bullseye'
          }, {
            id: 2,
            displayName: 'Campaign Emails',
            url: 'https://www.google.com',
            iconName: 'fas fa-bullhorn'
          }, {
            id: 3,
            displayName: 'Schedule & Send',
            url: 'https://www.google.com',
            iconName: 'fas fa-clock'
          }, {
            id: 4,
            displayName: 'Campaign Monitoring & History',
            url: 'https://www.google.com',
            iconName: 'fas fa-history'
          }, {
            id: 5,
            displayName: 'Statistics',
            url: 'https://www.google.com',
            iconName: 'fas fa-chart-pie'
          }, {
            id: 6,
            displayName: 'Sent Emails',
            url: 'https://www.google.com',
            iconName: 'fas fa-share-square'
          }]
        }
      }, {
        id: 77,
        module: 'letters',
        displayName: 'Letters',
        isActive: false,
        show: true,
        width: 0,
        subMenu: {
          menuLeftAlign: true,
          iconMenuTitle: 'Email menu panel',
          iconMenus: [{
            id: 1,
            displayName: 'Letter Merge',
            url: 'https://www.google.com',
            iconName: 'fas fa-project-diagram'
          }, {
            id: 2,
            displayName: 'Campaign Letters',
            url: 'https://www.google.com',
            iconName: 'fas fa-envelope'
          }]
        }
      }, {
        id: 8,
        module: 'store',
        displayName: 'Store',
        isActive: false,
        show: true,
        width: 0,
        subMenu: {
          menuLeftAlign: true,
          iconMenuTitle: 'Store menu Panel',
          iconMenus: [{
            id: 1,
            displayName: 'Orders',
            url: 'https://www.google.com',
            iconName: 'fas fa-tasks'
          }, {
            id: 2,
            displayName: 'Products',
            url: 'https://www.google.com',
            iconName: 'fas fa-tag'
          }, {
            id: 3,
            displayName: 'Inventory',
            url: 'https://www.google.com',
            iconName: 'fas fa-clipboard-check'
          }, {
            id: 4,
            displayName: 'Catalogs',
            url: 'https://www.google.com',
            iconName: 'fas fa-book-open'
          }, {
            id: 5,
            displayName: 'Settings',
            url: 'https://www.google.com',
            iconName: 'fas fa-cog'
          }]
        }
      }, {
        id: 9,
        module: 'volunteers',
        displayName: 'Volunteers',
        isActive: false,
        show: true,
        width: 0,
        subMenu: {
          menuLeftAlign: true,
          iconMenuTitle: 'Volunteer menu panel',
          iconMenus: [{
            id: 1,
            displayName: 'Projects',
            url: 'https://www.google.com',
            iconName: 'fas fa-folder-open'
          }, {
            id: 2,
            displayName: 'Applicants',
            url: 'https://www.google.com',
            iconName: 'fas fa-file-alt'
          }, {
            id: 3,
            displayName: 'Volunteers',
            url: 'https://www.google.com',
            iconName: 'fas fa-user-alt'
          }, {
            id: 4,
            displayName: 'Groups',
            url: 'https://www.google.com',
            iconName: 'fas fa-users'
          }, {
            id: 5,
            displayName: 'Time Sheets',
            url: 'https://www.google.com',
            iconName: 'fas fa-clock'
          }]
        }
      }, {
        id: 10,
        module: 'paymentProcessing',
        displayName: 'Payment Processing',
        isActive: false,
        show: true,
        width: 0,
        subMenu: {
          menuLeftAlign: true,
          iconMenuTitle: 'Payment Processing menu panel',
          iconMenus: [{
            id: 1,
            displayName: 'Verify Your Account',
            url: 'https://www.google.com',
            iconName: 'fas fa-user-check'
          }, {
            id: 2,
            displayName: 'Payments',
            url: 'https://www.google.com',
            iconName: 'fas fa-hand-holding-usd'
          }, {
            id: 3,
            displayName: 'Payouts',
            url: 'https://www.google.com',
            iconName: 'fas fa-user'
          }, {
            id: 4,
            displayName: 'Disputes',
            url: 'https://www.google.com',
            iconName: 'fas fa-exclamation-triangle'
          }, {
            id: 5,
            displayName: 'Balance',
            url: 'https://www.google.com',
            iconName: 'fas fa-balance-scale'
          }, {
            id: 6,
            displayName: 'Settings',
            url: 'https://www.google.com',
            iconName: 'fas fa-cog'
          }]
        }
      }, {
        id: 11,
        module: 'constantcontact',
        displayName: 'Constant Contact',
        isActive: false,
        show: true,
        width: 0,
        subMenu: {
          menuLeftAlign: true,
          iconMenuTitle: 'Constant Contact menu panel',
          iconMenus: [{
            id: 1,
            displayName: 'Getting Started',
            url: 'https://www.google.com',
            iconName: 'fas fa-question-circle'
          }, {
            id: 2,
            displayName: 'Lists',
            url: 'https://www.google.com',
            iconName: 'fas fa-list'
          }, {
            id: 3,
            displayName: 'Stats',
            url: 'https://www.google.com',
            iconName: 'fas fa-chart-pie'
          }, {
            id: 4,
            displayName: 'Sync',
            url: 'https://www.google.com',
            iconName: 'fas fa-sync'
          }, {
            id: 5,
            displayName: 'Settings',
            url: 'https://www.google.com',
            iconName: 'fas fa-cog'
          }]
        }
      }, {
        id: 12,
        module: 'files',
        displayName: 'Files',
        isActive: false,
        show: true,
        width: 0,
        subMenu: {
          menuLeftAlign: true,
          iconMenuTitle: 'File menu',
          iconMenus: [{
            id: 1,
            displayName: 'Files',
            url: 'https://www.google.com',
            iconName: 'fas fa-file'
          }, {
            id: 2,
            displayName: 'File Manager',
            url: 'https://www.google.com',
            iconName: 'fas fa-cogs'
          }]
        }
      }, {
        id: 13,
        module: 'webContent',
        displayName: 'Web Content',
        isActive: false,
        show: true,
        width: 0,
        subMenu: {
          menuLeftAlign: true,
          iconMenuTitle: 'Web Content menu',
          iconMenus: [{
            id: 1,
            displayName: 'Form Links & Landing Pages',
            url: 'https://www.google.com',
            iconName: 'fas fa-link'
          }, {
            id: 2,
            displayName: 'Custom Forms',
            url: 'https://www.google.com',
            iconName: 'fas fa-file-signature'
          }, {
            id: 3,
            displayName: 'Custom Web Pages',
            url: 'https://www.google.com',
            iconName: 'fas fa-globe'
          }, {
            id: 4,
            displayName: 'News Posts',
            url: 'https://www.google.com',
            iconName: 'fas fa-newspaper'
          }]
        }
      }, {
        id: 14,
        module: 'tools',
        displayName: 'Tools',
        isActive: false,
        show: true,
        width: 0,
        subMenu: {
          menuLeftAlign: true,
          iconMenuTitle: 'File menu',
          iconMenus: [{
            id: 1,
            displayName: 'Import Manager',
            url: 'https://www.google.com',
            iconName: 'fas fa-download'
          }, {
            id: 2,
            displayName: 'Duplicate Manager',
            url: 'https://www.google.com',
            iconName: 'fas fa-copy'
          }, {
            id: 3,
            displayName: 'Action Log',
            url: 'https://www.google.com',
            iconName: 'fas fa-list-ul'
          }, {
            id: 4,
            displayName: 'Workflows',
            url: 'https://www.google.com',
            iconName: 'fas fa-filter'
          }, {
            id: 5,
            displayName: 'Data Backup Utility',
            url: 'https://www.google.com',
            iconName: 'fas fa-database'
          }, {
            id: 6,
            displayName: 'Manage Deposits',
            url: 'https://www.google.com',
            iconName: 'fas fa-donate'
          }]
        }
      }, {
        id: 15,
        module: 'engagement',
        displayName: 'Engagement',
        isActive: false,
        show: true,
        width: 0,
        subMenu: {
          menuLeftAlign: true,
          iconMenuTitle: 'Engagement menu',
          iconMenus: [{
            id: 1,
            displayName: 'Activities',
            url: 'https://www.google.com',
            iconName: 'fas fa-clipboard-list'
          }, {
            id: 2,
            displayName: 'Grants',
            url: 'https://www.google.com',
            iconName: 'fas fa-donate'
          }, {
            id: 3,
            displayName: 'Prospects',
            url: 'https://www.google.com',
            iconName: 'fas fa-binoculars'
          }]
        }
      }, {
        id: 999,
        module: 'viewmore',
        displayName: 'View More',
        isActive: false,
        show: true,
        width: 0
      }],
      getLengthText: 'whatever',
      createMenuIsActive: false,
      myAccountMenuIsActive: false,
      editingMenu: false,
      notificationCenterActive: false,
      miniMyAccountMenu: false,
      miniMenu: false,
      miniSearchBox: false
    };
  },

  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_3__fortawesome_vue_fontawesome___default.a,
    draggable: __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default.a,
    notificationCenter: __WEBPACK_IMPORTED_MODULE_1__components_NotificationCenter__["a" /* default */],
    FontLoaded: __WEBPACK_IMPORTED_MODULE_6_font_loaded___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_7_vue_multiselect___default.a
  },
  directives: {
    clickoutside: clickoutside
  },
  methods: {
    jumpMenu: function jumpMenu(menuId) {
      alert(menuId);
      if (menuId === 1) {
        location.href = '/about.html';
      } else if (menuId === 2) {
        location.href = '/index.html';
      } else {
        alert('No Page');
      }
    },
    toggleMiniMenu: function toggleMiniMenu() {
      this.miniMenu = !this.miniMenu;
    },
    toggle: function toggle(module, event) {
      for (var index in this.menus) {
        if (this.menus[index].module === module) {
          if (document.getElementById(module).contains(event.target)) {
            if (event.target.classList.contains('navigation_menu') || event.target.classList.contains('navigation_menu_label') || event.target.classList.contains('navigation_menu_dropdown_arrow')) {
              this.menus[index].isActive = !this.menus[index].isActive;
            }
          } else {
            this.menus[index].isActive = !this.menus[index].isActive;
          }
        } else {
          console.log('in toggle');
          console.log(event.target.classList);
          this.menus[index].isActive = false;
        }
      }
    },
    toggleClose: function toggleClose() {
      for (var index in this.menus) {
        console.log('in toggleClose');
        this.menus[index].isActive = false;
      }
    },
    miniMenuToggle: function miniMenuToggle(module) {
      if (module === 'myAccount') {
        this.miniMyAccountMenu = !this.miniMyAccountMenu;
        for (var index in this.menus) {
          console.log('in miniMenuToggle my account ');
          this.menus[index].isActive = false;
        }
      } else {
        for (var index2 in this.menus) {
          if (this.menus[index2].module === module) {
            this.menus[index2].isActive = !this.menus[index2].isActive;
          } else {
            console.log('in miniMenuToggle');
            this.menus[index2].isActive = false;
          }
        }
        this.miniMyAccountMenu = false;
      }
    },
    viewMoreMenuToggle: function viewMoreMenuToggle(module) {
      for (var index in this.menus) {
        if (this.menus[index].module === module) {
          this.menus[index].isActive = !this.menus[index].isActive;
        } else if (this.menus[index].module === 'viewmore') {
          // do nothing
        } else {
          console.log('in viewMoreMenuToggle');
          this.menus[index].isActive = false;
        }
      }
    },
    hidenc: function hidenc() {
      this.notificationCenterActive = !this.notificationCenterActive;
    },
    hideDialog: function hideDialog() {
      this.notificationCenterActive = false;
    },
    shakeit: function shakeit() {
      if (document.getElementsByClassName('notification_shake_number')[0].classList.contains('shake')) {
        document.getElementsByClassName('notification_shake_number')[0].classList.remove('shake');
      } else {
        document.getElementsByClassName('notification_shake_number')[0].classList.add('shake');
      }
    },
    toggleCreateMenu: function toggleCreateMenu() {
      this.createMenuIsActive = true;
    },
    toggleMyAccountMenu: function toggleMyAccountMenu() {
      this.myAccountMenuIsActive = true;
    },
    toggleMiniSearchBox: function toggleMiniSearchBox() {
      this.miniSearchBox = !this.miniSearchBox;
    },
    closeCreateMenu: function closeCreateMenu() {
      this.createMenuIsActive = false;
    },
    toggleMenuEditor: function toggleMenuEditor() {
      this.editingMenu = !this.editingMenu;
      if (this.editingMenu) {
        this.cloneMenus = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.menus));
      } else {
        this.cloneMenus = null;
      }
    },
    closeMyAccountMenu: function closeMyAccountMenu() {
      this.myAccountMenuIsActive = false;
    },
    rollBackMenuChanges: function rollBackMenuChanges() {
      this.cloneMenus = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.menus));
    },
    saveMenuChanges: function saveMenuChanges() {
      this.menus = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.cloneMenus));
      this.cloneMenus = null;
      this.handleResize();
      this.editingMenu = false;
    },
    endDrag: function endDrag(evt) {
      if (this.cloneMenus === undefined || this.cloneMenus === null) {
        this.cloneMenus = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.menus));
      }

      if (evt.newIndex !== evt.oldIndex) {
        var oldNodeTemp = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.cloneMenus[evt.oldIndex]));
        this.cloneMenus.splice(evt.oldIndex, 1);
        this.cloneMenus.splice(evt.newIndex, 0, oldNodeTemp);
      }
    },
    getMenuLenght: function getMenuLenght(displayName) {
      document.getElementById('invisibleMenu').innerText = displayName;
      return document.getElementById('invisibleMenu').clientWidth;
    },
    handleResize: function handleResize() {
      var screenWidth = document.body.clientWidth;
      var rightIconsWidth = document.getElementById('tnRightMenu').clientWidth;
      var menuMaxWidth = screenWidth - rightIconsWidth;
      var totalMenuWidth = 0;
      var totalWidth = this.getMenuLenght('View More');

      for (var index in this.menus) {
        var arrow = 0;
        if (this.menus[index].subMenu !== undefined && this.menus[index].subMenu !== null) {
          arrow = 18;
          /* if menu contains arrow */
        }
        if (this.menus[index].width === 0) {
          var textWidth = this.getMenuLenght(this.menus[index].displayName) + arrow;
          this.menus[index].width = textWidth;
        }
        if (this.menus[index].module !== 'viewmore') {
          totalMenuWidth = this.getMenuLenght(this.menus[index].displayName) + totalMenuWidth + arrow;
        }
      }

      if (totalMenuWidth < menuMaxWidth) {
        totalWidth = 0;
        for (var inx in this.menus) {
          if (this.menus[inx].module === 'viewmore') {
            this.menus[inx].show = false;
          }
        }
      } else {
        for (var inx2 in this.menus) {
          if (this.menus[inx2].module === 'viewmore') {
            this.menus[inx2].show = true;
          }
        }
        totalWidth = this.getMenuLenght('View More');
      }

      for (var index3 in this.menus) {
        var arrowWidth = 0;
        if (this.menus[index3].subMenu !== undefined && this.menus[index3].subMenu !== null) {
          arrowWidth = 18;
          /* if menu contains arrow */
        }

        console.log(this.menus[index3].module);
        console.log(arrowWidth);

        if (this.menus[index3].module !== 'viewmore' && totalWidth + arrowWidth + this.getMenuLenght(this.menus[index3].displayName) > menuMaxWidth) {
          this.menus[index3].show = false;
        } else if (this.menus[index3].module !== 'viewmore') {
          this.menus[index3].show = true;
          if (this.menus[index3].subMenu !== undefined && this.menus[index3].subMenu !== null) {
            if (menuMaxWidth - totalWidth < 300) {
              this.menus[index3].subMenu.menuLeftAlign = false;
            } else {
              this.menus[index3].subMenu.menuLeftAlign = true;
            }
          }
        }

        if (this.menus[index3].module !== 'viewmore') {
          totalWidth = this.getMenuLenght(this.menus[index3].displayName) + totalWidth + arrowWidth;
        }
        console.log(totalWidth);
      }
    },
    getResult: function getResult() {
      var _this = this;

      this.isLoading = true;
      fetch('https://jsonplaceholder.typicode.com/posts/1').then(function (response) {
        _this.searchResults = [{

          type: 'Accounts',
          displayName: 'Accounts',
          isGroup: true,
          results: [{
            isGroup: false,
            type: 'Accounts',
            trackId: 'account-2',
            accountId: '2',
            fullName: 'Jaina Proudmoore',
            displayName: 'Jaina Proudmoore',
            accountType: 'individual',
            isShowMore: false,
            address1: '',
            addressLocate: ''
          }, {
            isGroup: false,
            type: 'Accounts',
            trackId: 'account-3',
            accountId: '3',
            fullName: 'Sylvanas Windrunner',
            displayName: 'Sylvanas Windrunner',
            accountType: 'individual',
            isShowMore: false,
            address1: '',
            addressLocate: ''
          }, {
            isGroup: false,
            type: 'Accounts',
            trackId: 'account-4',
            accountId: '4',
            fullName: 'Valeera Sanguinar',
            displayName: 'Valeera Sanguinar',
            accountType: 'individual',
            isShowMore: false,
            address1: '',
            addressLocate: ''
          }, {
            isGroup: false,
            type: 'Accounts',
            trackId: 'account-6',
            accountId: '6',
            fullName: 'Alexstrasza',
            displayName: 'Alexstrasza',
            accountType: 'individual',
            isShowMore: false,
            address1: '',
            addressLocate: ''
          }, {
            isGroup: false,
            type: 'Accounts',
            trackId: 'account-5',
            accountId: '5',
            fullName: 'Venture Co.',
            displayName: 'Venture Co.',
            accountType: 'organization',
            isShowMore: false,
            address1: '',
            addressLocate: ''
          }, {
            isGroup: false,
            isShowMore: true,
            showMoreLink: 'ssssss',
            type: 'showMore'
          }]
        }, {
          type: 'Households',
          isGroup: true,
          results: [{
            type: 'Households',
            trackId: 'household-1',
            householdId: '1',
            householdName: 'Stormrage Family',
            displayName: 'Stormrage Family',
            householdDescription: 'What\'s this?',
            isShowMore: false
          }, {
            type: 'Households',
            trackId: 'household-2',
            householdId: '2',
            householdName: 'The Flintstones',
            displayName: 'The Flintstones',
            householdDescription: 'What\'s this?',
            isShowMore: false
          }, {
            isGroup: false,
            isShowMore: true,
            showMoreLink: 'ssssss',
            type: 'showMore'
          }]
        }, {
          type: 'Events',
          isGroup: true,
          results: [{
            type: 'Events',
            trackId: 'event-1',
            eventId: '1',
            eventName: 'Blizzcon 2018',
            displayName: 'Blizzcon 2018',
            eventDescription: 'What\'s this?',
            isShowMore: false
          }, {
            type: 'Events',
            trackId: 'event-2',
            eventId: '2',
            eventName: 'E3',
            displayName: 'E3',
            eventDescription: 'What\'s this?',
            isShowMore: false
          }, {
            isGroup: false,
            isShowMore: true,
            showMoreLink: 'ssssss',
            type: 'showMore'
          }]
        }, {
          type: 'Campaigns',
          isGroup: true,
          results: [{
            type: 'Campaigns',
            trackId: 'campaign-1',
            campaignId: '1',
            campaignName: 'Pokemon Go',
            displayName: 'Pokemon Go',
            campaignDescription: 'What\'s this?',
            isShowMore: false
          }, {
            type: 'Campaigns',
            trackId: 'campaign-2',
            campaignId: '12',
            campaignName: 'I have no idea',
            displayName: 'I have no idea',
            campaignDescription: 'What\'s this?',
            isShowMore: false
          }, {
            isGroup: false,
            isShowMore: true,
            showMoreLink: 'ssssss',
            type: 'showMore'
          }]
        }];
        _this.isLoading = false;
      });
    },
    closeSearch: function closeSearch() {
      var multiselectActive = document.querySelectorAll('.neon_search_result .multiselect--active')[0];
      var multiselectWrapper = document.querySelectorAll('.neon_search_result .multiselect__content-wrapper')[0];
      multiselectWrapper.style.display = 'none';
      multiselectActive.classList.remove('multiselect--active');
      this.searchResults = [];
    },
    clearResult: function clearResult() {
      var multiselectActive = document.querySelectorAll('.neon_search_result .multiselect--active')[0];
      var multiselectWrapper = document.querySelectorAll('.neon_search_result .multiselect__content-wrapper')[0];
      multiselectWrapper.style.display = 'none';
      multiselectActive.classList.remove('multiselect--active');
      this.searchResults = [];
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.handleResize);

    this.handleResize();
  }
});

/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_free_solid__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_directive_tooltip__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_directive_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_directive_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_directive_tooltip_css_index_css__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_directive_tooltip_css_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_directive_tooltip_css_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__webpack_require__(18);

__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome__["default"].library.add(__WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_free_solid__["a" /* default */]);

var clickoutside = {
  inserted: function inserted(el, binding, vnode) {
    function documentHandler(e) {
      if (el.contains(e.target)) {
        return false;
      }

      if (binding.expression) {
        binding.value();
      }
    }
    el.__vueClickOutside__ = documentHandler;
    document.addEventListener('click', documentHandler);
  },
  update: function update() {},
  unbind: function unbind(el, binding) {
    document.removeEventListener('click', el.__vueClickOutside__);
    delete el.__vueClickOutside__;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notificationCenter',
  data: function data() {
    return {
      active: false,
      filterDropdownActive: false,
      currentFilter: 'All',
      unreadNumber: 9527,
      filterTypes: [{
        id: 0,
        type: 'All',
        selected: true,
        isCheckAll: true,
        disabled: false
      }, {
        id: 1,
        type: 'Activity',
        selected: false,
        isCheckAll: false,
        disabled: false
      }, {
        id: 2,
        type: 'Duplicate Scan',
        selected: false,
        isCheckAll: false,
        disabled: false
      }, {
        id: 3,
        type: 'Executive Report',
        selected: false,
        isCheckAll: false,
        disabled: false
      }],
      justCloseNovigation: false,
      notifications: [{
        id: 1,
        type: 'system',
        isHighlight: true,
        date: '08/02/2018',
        title: 'What\'s new with NeonCRM',
        subject: '08/03/2018 Release Notes',
        content: 'Fenix Stats Health reduced from 1200 to 1140. Health Regeneration reduced from 2.50 to 2.38. Shields reduced from 800 to 760. Shield Regeneration reduced from 80 to 76.',
        isExpand: false,
        unread: false
      }, {
        id: 2,
        type: 'activity',
        isHighlight: false,
        date: '13/01/9999',
        title: 'Activity',
        subject: 'North Korea sent a Rocket to lunar',
        content: 'That\'s one small step for man, one giant leap for mankind.',
        isExpand: false,
        unread: false
      }, {
        id: 4,
        type: 'activity',
        isHighlight: false,
        date: '05/01/2025',
        title: 'Activity',
        subject: 'NeonCRM opens Fire Island division',
        content: 'NeonCRM is the biggest meat factory of the whole universe. Fire Island government built a ice block with 2 kilometer diameter, and give to NeonCRM as a present.',
        isExpand: false,
        unread: false
      }, {
        id: 5,
        type: 'activity',
        isHighlight: false,
        date: '04/01/1988',
        title: 'Activity',
        subject: 'Portal has bee invented',
        content: 'This is an ProtoMech. The inventor\'s name is Mickey Trump, Who is Donald Trump\'s aunt\'s brother\'s dad\'s daughter\'s whatever\'s friend. Don\' ask me, I don\'t know why his last name is Trump. But wait, this is not important. The portal can transfer an adult from his computer to the toilet. ',
        isExpand: false,
        unread: false
      }, {
        id: 6,
        type: 'activity',
        isHighlight: false,
        date: '05/30/2018',
        title: 'Activity',
        subject: 'Edward Shen win the Nobel Prize',
        content: 'Edward Shen is the greatest scientist in Azeroth.',
        isExpand: false,
        unread: false
      }]
    };
  },

  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default.a,
    Tooltip: __WEBPACK_IMPORTED_MODULE_3_vue_directive_tooltip___default.a
  },
  directives: {
    clickoutside: clickoutside
  },
  props: ['panelActive'],
  methods: {
    tohide: function tohide() {
      console.log('click close');
      this.$emit('xoxoxox');
    },
    closeFilterDropdown: function closeFilterDropdown() {
      this.filterDropdownActive = false;
    },
    toggleFilterDropdown: function toggleFilterDropdown() {
      this.filterDropdownActive = !this.filterDropdownActive;
    },
    setCurrentFilter: function setCurrentFilter(value) {
      var displayString = '';
      for (var index in this.filterTypes) {
        if (value === this.filterTypes[index].type) {
          this.filterTypes[index].selected = !this.filterTypes[index].selected;
        } else {
          this.filterTypes[index].selected = false;
        }

        if (this.filterTypes[index].selected) {
          if (displayString !== '') {
            displayString += ', ';
          }

          displayString += this.filterTypes[index].type;
        }
      }

      this.currentFilter = displayString;
    },
    expandNotification: function expandNotification(notificationId, e) {
      if (e.target.classList.contains('notification_title_hover')) {
        return false;
      }
      if (e.target.classList.contains('clickable')) {
        return false;
      }

      for (var index in this.notifications) {
        if (this.notifications[index].id === notificationId) {
          this.notifications[index].isExpand = true;
          this.notifications[index].unread = false;
        } else {
          this.notifications[index].isExpand = false;
        }
      }
      e.preventDefault();
    },
    closeNotification: function closeNotification(notificationId, e) {
      if (e.target.classList.contains('clickable')) {
        return false;
      }
      for (var index in this.notifications) {
        if (this.notifications[index].id === notificationId) {
          this.notifications[index].isExpand = false;
        } else {
          this.notifications[index].isExpand = false;
        }
      }
      e.preventDefault();
    },
    changeReadStatus: function changeReadStatus(index) {
      this.notifications[index].unread = !this.notifications[index].unread;
    },
    showSplash: function showSplash() {
      this.$modal.show('splash');
    },
    hideSplash: function hideSplash() {
      this.$modal.hide('splash');
    },
    handleTopScroll: function handleTopScroll() {
      document.getElementById('notificationCenter').style.top = window.scrollY + 'px';
    },

    load: function load() {
      console.log('loaded');
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.handleTopScroll);
  },
  destroy: function destroy() {
    window.removeEventListener('scroll', this.handleResize);
  },
  watch: {
    panelActive: function panelActive() {
      if (this.panelActive) {
        this.handleTopScroll();
      }
    }
  }
});

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'neon-footer',
  data: function data() {
    return {};
  },

  components: {},
  methods: {}
});

/***/ }),

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Header__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Footer__ = __webpack_require__(65);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    'neon-header': __WEBPACK_IMPORTED_MODULE_0__common_Header__["a" /* default */],
    'neon-footer': __WEBPACK_IMPORTED_MODULE_1__common_Footer__["a" /* default */]
  }
});

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addI18nModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_directive_tooltip__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_directive_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_directive_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_responsive__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_js_modal__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_timeago__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_i18n__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lang_DateTimeFormat__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_resource__ = __webpack_require__(99);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__webpack_require__(31);
__webpack_require__(32);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_directive_tooltip___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_responsive__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_js_modal___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_timeago__["a" /* default */], {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: undefined, // Default locale
  locales: {
    'zh-CN': __webpack_require__(101),
    'ja': __webpack_require__(102)
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var i18n = new __WEBPACK_IMPORTED_MODULE_6_vue_i18n__["a" /* default */]({
  locale: 'zh-CN',
  messages: {
    'en-US': __webpack_require__(33),
    'zh-CN': __webpack_require__(34)
  },
  dateTimeFormats: __WEBPACK_IMPORTED_MODULE_7__lang_DateTimeFormat__["a" /* default */],
  fallbackLocale: 'en-US'
});

function addI18nModule(module) {
  i18n.mergeLocaleMessage('en-US', __webpack_require__(35)("./" + module + '/en-US'));
  i18n.mergeLocaleMessage('zh-CN', __webpack_require__(37)("./" + module + '/zh-CN'));
  return i18n;
}



/***/ }),

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var dateTimeFormats = {
  'en-US': {
    short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric'
    }
  },
  'zh-CN': {
    short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: true
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (dateTimeFormats);

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

module.exports = {
  common: {
    title: 'NeonCRM',
    copyright: 'NeonCRM Copyright © 2018 Z2 Systems, Inc. All rights reserved.',
    language: 'Language'
  }
};

/***/ }),

/***/ 34:
/***/ (function(module, exports) {

module.exports = {
  common: {
    title: '理奥CRM',
    copyright: 'NeonCRM Copyright © 2018 Z2 Systems, Inc. All rights reserved.',
    language: '语言'
  }
};

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./i18n-demo/en-US": 36
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

module.exports = {
  'i18n-demo': {
    message: {
      title: 'Sport Brands<br/> top 5'
    },
    placeholder: {
      enter: 'Please type in your favorite brand'
    },
    brands: {
      nike: 'Nike',
      adi: 'Adidas',
      nb: 'New Banlance',
      ln: 'LI Ning',
      at: 'Anta'
    },
    love: 'I like {brand}',
    label_date: 'Now is: '
  }

};

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./i18n-demo/zh-CN": 38
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

module.exports = {
  'i18n-demo': {
    message: {
      title: '运动品牌<br/>top 5'
    },
    placeholder: {
      enter: '请输入您喜欢的品牌'
    },
    brands: {
      nike: '耐克',
      adi: '阿迪达斯',
      nb: '新百伦',
      ln: '李宁'
    },
    love: '我喜欢{brand}',
    label_date: '现在是: '
  }
};

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);


var SessionContext = {
  setUserContext: function setUserContext(userContext) {
    sessionStorage.setItem('userContext', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userContext));
  },
  getUserContext: function getUserContext() {
    var userContextStr = sessionStorage.getItem('userContext');
    if (userContextStr && userContextStr !== '') {
      return JSON.parse(userContextStr);
    }
    return {};
  },
  clearUserContext: function clearUserContext() {
    sessionStorage.removeItem('userContext');
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SessionContext);

/***/ }),

/***/ 498:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_vue__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_main_js__ = __webpack_require__(26);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__index_vue__["a" /* default */] }
});

/***/ }),

/***/ 499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(207);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7aee6022_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(501);
function injectStyle (ssrContext) {
  __webpack_require__(500)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7aee6022"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7aee6022_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 500:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('neon-header'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('neon-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"index-main"},[_vm._v("\n        Here is Index Page.\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3e8c5e4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(64);
function injectStyle (ssrContext) {
  __webpack_require__(53)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3e8c5e4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 53:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationCenter_vue__ = __webpack_require__(15);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30f6dade_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationCenter_vue__ = __webpack_require__(58);
function injectStyle (ssrContext) {
  __webpack_require__(55)
  __webpack_require__(56)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30f6dade"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationCenter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30f6dade_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationCenter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 55:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 56:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"bounceRight"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.panelActive),expression:"panelActive"}],attrs:{"id":"notificationCenter"},on:{"load":_vm.load}},[_c('div',{staticClass:"notification_header"},[_c('div',{staticClass:"notification_banner flex_display"},[_c('div',{staticClass:"div_aline_left"},[_c('span',{staticClass:"notification_center_title"},[_c('font-awesome-icon',{staticClass:"notification_center_title_icon",attrs:{"icon":['fas', 'bell']}}),_vm._v(" Notifications")],1)]),_vm._v(" "),_c('div',{staticClass:"div_aline_right notification_center_header_right"},[_c('div',{staticClass:"icons"},[_c('div',{staticClass:"icon-box"},[_c('svg',{staticClass:"icon-close scale",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12"},on:{"click":_vm.tohide}},[_c('title',[_vm._v("Close")]),_c('polygon',{attrs:{"points":"12 1.4 10.6 0 6 4.6 1.4 0 0 1.4 4.6 6 0 10.6 1.4 12 6 7.4 10.6 12 12 10.6 7.4 6 12 1.4"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"notification_splash flex_display"},[_c('div',{staticClass:"div_aline_left splash_information_container"},[_c('div',{staticClass:"splash_information_date"},[_vm._v("\n            System update - June 2018\n          ")]),_vm._v(" "),_c('div',{staticClass:"splash_information_wutsnew"},[_vm._v("\n            What's new in Neon?\n          ")])]),_vm._v(" "),_c('div',{staticClass:"div_aline_right flex_display splash_information_wutsnew_container"},[_c('button',{staticClass:"neon_btn neon_btn_default flex_display_centered_child",on:{"click":_vm.showSplash}},[_vm._v("\n            See the updates\n          ")]),_vm._v(" "),_c('modal',{attrs:{"name":"splash","width":1100,"height":800,"classes":['splash_modal', 'v--modal']}},[_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"flex_display"},[_c('h3',{staticClass:"flex_display_centered_child"},[_vm._v(" You got a message from future ")])]),_vm._v(" "),_c('div',{staticClass:"flex_display"},[_c('img',{staticClass:"flex_display_centered_child",attrs:{"src":__webpack_require__(59)}})])])])],1),_vm._v(" "),_c('div')]),_vm._v(" "),_c('div',{staticClass:"flex_display",attrs:{"id":"notification_filter"}},[_c('div',{staticClass:"div_aline_left notification_unread_message_container"},[_c('div',{staticClass:"notification_unread_message"},[_vm._v("\n            "+_vm._s(_vm.unreadNumber)+" unread notifications\n          ")]),_vm._v(" "),_c('div',{staticClass:"notification_mark_as_read_link"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Mark as read?")])])]),_vm._v(" "),_c('div',{staticClass:"div_aline_right flex_display notification_center_filter_right"},[_c('div',{staticClass:"notification_center_show_unread flex_display"},[_c('div',{staticClass:"notification_center_show_unread_label"},[_vm._v("Unread only")]),_vm._v(" "),_c('div',{staticClass:"notification_center_show_unread_checkbox flex_display"},[_c('input',{staticClass:"flex_display_centered_child",attrs:{"type":"checkbox"}})])]),_vm._v(" "),_c('div',{staticClass:"notification_center_filter_label"},[_vm._v("\n            Default Filter:\n          ")]),_vm._v(" "),_c('b-dropdown',{staticClass:"m-2 bootstrap_button_dropdown bootstrap_notification_filter",attrs:{"right":"","variant":"link","text":_vm.currentFilter,"no-caret":"","toggle-class":"arrow_controller"}},[_c('template',{slot:"button-content"},[_c('div',{staticClass:"flex_display notification_center_filter_button"},[_c('div',{staticClass:"notification_center_filter_button_label"},[_vm._v("\n                  "+_vm._s(_vm.currentFilter)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"filter_dropdown dropdown_arrow_small div_aline_right"})])]),_vm._v(" "),_vm._l((_vm.filterTypes),function(filterType){return _c('b-dropdown-item',{key:filterType.id,staticClass:"neon_dropdown_item check_icon",on:{"click":function($event){_vm.setCurrentFilter(filterType.type)}}},[_c('div',{staticClass:"flex_display"},[_c('div',{staticClass:"neon_dropdown_selected"},[(filterType.selected)?_c('font-awesome-icon',{staticClass:"notification_center_title_icon",attrs:{"icon":['fas', 'check']}}):_vm._e()],1),_vm._v("\n                "+_vm._s(filterType.type)+"\n              ")])])})],2)],1)])]),_vm._v(" "),_c('div',{attrs:{"id":"notificationContent"}},[_c('div',{staticClass:"notification_content_container"},[_c('ul',{staticClass:"notification_content_list"},_vm._l((_vm.notifications),function(notification,index){return _c('li',{key:index,staticClass:"notification_content_list_item",class:{ notification_hover : !notification.isExpand, notification_no_hover: notification.isExpand },on:{"click":function($event){!notification.isExpand && _vm.expandNotification(notification.id, $event)}}},[_c('div',{staticClass:"notification_cell",class:{ notification_unread : notification.unread, notification_read : !notification.unread, }},[_c('div',{staticClass:"notification_cell_detail"},[_c('div',{staticClass:"flex_display notification_cell_header",class:{ notification_title_hover: notification.isExpand,  notification_title_no_hover: !notification.isExpand },on:{"click":function($event){notification.isExpand && _vm.closeNotification(notification.id, $event)}}},[_c('div',{staticClass:"div_aline_left flex_display"},[_c('div',{staticClass:"notification_cell_icon"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'calendar-alt']}})],1),_vm._v(" "),_c('div',{staticClass:"notification_cell_title"},[_vm._v("\n                    "+_vm._s(notification.title)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"div_aline_right"},[_c('div',{staticClass:"notification_cell_actions flex_display"},[_c('div',{staticClass:"notification_cell_action"},[_c('a',{staticClass:"clickable",attrs:{"href":"#"},on:{"click":function($event){_vm.changeReadStatus(index)}}},[_vm._v(_vm._s(notification.unread ? 'Mark as read' : 'Mark as unread'))])])])])]),_vm._v(" "),_c('div',{staticClass:"notification_cell_subject_time_ago"},[_c('div',{staticClass:"notification_cell_subject"},[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(notification.subject))])]),_vm._v(" "),_c('timeago',{staticClass:"notification_time_ago",attrs:{"since":notification.date}})],1),_vm._v(" "),_c('div',{staticClass:"notification_cell_brief"},[_c('div',{class:{notification_cell_brief_text_full:notification.isExpand, notification_cell_brief_text:!notification.isExpand}},[_c('span',[_vm._v(_vm._s(notification.content))])])])])])])}))])]),_vm._v(" "),_c('div',{attrs:{"id":"notification_footer"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/future.15d3b78.png";

/***/ }),

/***/ 61:
/***/ (function(module, exports) {

/**
 * Created by Edward Shen on 6/11/2018.
 */

window.zESettings = {
  webWidget: {
    offset: {
      vertical: '34px',
      mobile: {
        vertical: '34px'
      }
    }
  }

  /*<![CDATA[*/ };window.zEmbed || function (e, t) {
  var n,
      o,
      d,
      i,
      s,
      a = [],
      r = document.createElement("iframe");window.zEmbed = function () {
    a.push(arguments);
  }, window.zE = window.zE || window.zEmbed, r.src = "javascript:false", r.title = "", r.role = "presentation", (r.frameElement || r).style.cssText = "display: none", d = document.getElementsByTagName("script"), d = d[d.length - 1], d.parentNode.insertBefore(r, d), i = r.contentWindow, s = i.document;try {
    o = s;
  } catch (e) {
    n = document.domain, r.src = 'javascript:var d=document.open();d.domain="' + n + '";void(0);', o = s;
  }o.open()._l = function () {
    var e = this.createElement("script");n && (this.domain = n), e.id = "js-iframe-async", e.src = "https://assets.zendesk.com/embeddable_framework/main.js", this.t = +new Date(), this.zendeskHost = "z2.zendesk.com", this.zEQueue = a, this.body.appendChild(e);
  }, o.write('<body onload="document._l();">'), o.close();
}(); /*]]>*/

/***/ }),

/***/ 62:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 63:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',[_c('div',{directives:[{name:"responsive",rawName:"v-responsive.sm.xs",modifiers:{"sm":true,"xs":true}}],attrs:{"id":"miniTitanNavigation"}},[_c('div',{staticClass:"flex_display",attrs:{"id":"miniTnActions"}},[_c('div',{staticClass:"div_aline_left flex_display",attrs:{"id":"miniTnLeftActions"}},[_c('div',{attrs:{"id":"miniTnMenuToggle"},on:{"click":_vm.toggleMiniMenu}},[_vm._m(0)]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"div_aline_right flex_display",attrs:{"id":"miniTnRightActions"}},[_c('div',{staticClass:"flex_display",attrs:{"id":"miniTnIconBtns"}},[_c('b-dropdown',{staticClass:"bootstrap_button_dropdown bootstrap_mini_create_new",attrs:{"right":"","variant":"link","no-caret":""}},[_c('template',{slot:"button-content"},[_c('div',{staticClass:"navigation_circle_style navigation_mini_icon flex_display transparent_bg"},[_c('span',[_c('i',{staticClass:"fas fa-cog",attrs:{"aria-hidden":"true"}})])])]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("System Settings Home")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("Organization Profile")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("2-Step Verification")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("User Groups/Permissions")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("System Users")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("Data Backup Utility")])],2),_vm._v(" "),_c('div',{staticClass:"navigation_circle_style navigation_mini_icon flex_display transparent_bg",class:{ mini_search_active: _vm.miniSearchBox, mini_search_hide: !_vm.miniSearchBox },on:{"click":_vm.toggleMiniSearchBox}},[_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"flex_display",attrs:{"id":"tnaMiniIconNotification"}},[_c('div',{staticClass:"navigation_circle_style navigation_mini_icon flex_display transparent_bg flex_display_centered_child_vertical",on:{"click":function($event){_vm.hidenc()}}},[_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"notification_mini_shake_number navigation_circle_style flex_display shake",on:{"click":function($event){_vm.shakeit()}}},[_c('span',{staticClass:"navigation_notification_center_label"},[_vm._v("\n                  99\n                ")])])]),_vm._v(" "),_c('b-dropdown',{staticClass:"bootstrap_button_dropdown bootstrap_mini_create_new",attrs:{"right":"","variant":"link","no-caret":""}},[_c('template',{slot:"button-content"},[_c('div',{staticClass:"navigation_circle_style mini_navigation_create_action flex_display"},[_c('span',[_c('i',{staticClass:"fas fa-plus-circle",attrs:{"aria-hidden":"true"}})])])]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("New Individual")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("New Organization")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("New Donation")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("New Event Registration")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("New Store Order")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("New Membership")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("New Pledge")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("New Activity")])],2)],1)])]),_vm._v(" "),(_vm.miniSearchBox)?_c('div',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.toggleMiniSearchBox),expression:"toggleMiniSearchBox"}],attrs:{"id":"miniTnSearch"}},[_c('div',{staticClass:"mini_navigation_search_container flex_display"},[_c('div',{staticClass:"neon_search_result demo_search_select_mini snipped flex_display_centered_child"},[_c('i',{staticClass:"fas fa-search tital_search_icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.searchResults,"multiple":true,"group-values":"results","group-label":"type","group-select":true,"close-on-select":false,"track-by":"trackId","label":"trackId","placeholder":"Search by Name, ID or Email","max-height":1000,"show-labels":false,"internal-search":false,"clear-on-select":true,"hide-selected":false},on:{"search-change":_vm.getResult,"close":_vm.clearResult},scopedSlots:_vm._u([{key:"option",fn:function(props){return [(props.option.$isLabel)?_c('div',{staticClass:"search_result_group_bar"},[_c('span',{staticClass:"search_result_group_bar_label"},[_vm._v(_vm._s(props.option.$groupLabel))])]):(!props.option.isGroup && props.option.type === 'Accounts')?_c('div',{staticClass:"search_result_item flex_display"},[_c('div',{staticClass:"flex_display search_result_item_icon"},[_c('div',{staticClass:"flex_display_centered_child"},[_c('i',{staticClass:"fas fa-plus-circle",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"search_result_item_content"},[_c('div',{staticClass:"search_result_item_content_title"},[_c('a',{on:{"click":function($event){_vm.closeSearch()}}},[_vm._v(_vm._s(props.option.displayName))])]),_vm._v(" "),_c('div',{staticClass:"search_result_item_content_description"},[_vm._v(_vm._s(props.option.accountType))])])]):(!props.option.isGroup && props.option.type === 'Households')?_c('div',{staticClass:"search_result_item flex_display"},[_c('div',{staticClass:"flex_display search_result_item_icon"},[_c('div',{staticClass:"flex_display_centered_child"},[_c('i',{staticClass:"fas fa-plus-circle",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"search_result_item_content"},[_c('div',{staticClass:"search_result_item_content_title"},[_c('a',{on:{"click":function($event){_vm.closeSearch()}}},[_vm._v(_vm._s(props.option.householdName))])]),_vm._v(" "),_c('div',{staticClass:"search_result_item_content_description"},[_vm._v(_vm._s(props.option.householdDescription))])])]):(!props.option.isGroup && props.option.type === 'Campaigns')?_c('div',{staticClass:"search_result_item flex_display"},[_c('span',{staticClass:"option__title"},[_vm._v("\n                  "+_vm._s(props.option.displayName)+"\n                ")])]):(!props.option.isGroup && props.option.type === 'Events')?_c('div',{staticClass:"search_result_item flex_display"},[_c('span',{staticClass:"option__title"},[_vm._v("\n                  "+_vm._s(props.option.displayName)+"\n                ")])]):(!props.option.isGroup && props.option.type === 'showMore')?_c('div',{staticClass:"search_result_show_more flex_display"},[_c('a',{staticClass:"search_result_show_more_link div_aline_right",on:{"click":function($event){_vm.closeSearch()}}},[_vm._v("Show more ")])]):_vm._e()]}}])},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v("Oops! No elements found. Consider changing the search query.")])])],1)]),_vm._v(" "),_vm._m(4)]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"responsive",rawName:"v-responsive.md.lg.xl",modifiers:{"md":true,"lg":true,"xl":true}}],attrs:{"id":"titanNavigation"}},[_c('div',{staticClass:"flex_display",attrs:{"id":"tnActions"}},[_c('div',{staticClass:"div_aline_left flex_display",attrs:{"id":"tnLeftActions"}},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"flex_display",attrs:{"id":"tnaSearchBox"}},[_c('div',{staticClass:"neon_search_result demo_search_select snipped flex_display_centered_child"},[_c('i',{staticClass:"fas fa-search tital_search_icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.searchResults,"multiple":true,"group-values":"results","group-label":"type","group-select":true,"close-on-select":false,"track-by":"trackId","label":"trackId","placeholder":"Search by Name, ID or Email","max-height":1000,"show-labels":false,"internal-search":false,"clear-on-select":true,"hide-selected":false},on:{"search-change":_vm.getResult,"close":_vm.clearResult},scopedSlots:_vm._u([{key:"option",fn:function(props){return [(props.option.$isLabel)?_c('div',{staticClass:"search_result_group_bar"},[_c('span',{staticClass:"search_result_group_bar_label"},[_vm._v(_vm._s(props.option.$groupLabel))])]):(!props.option.isGroup && props.option.type === 'Accounts')?_c('div',{staticClass:"search_result_item flex_display"},[_c('div',{staticClass:"flex_display search_result_item_icon"},[_c('div',{staticClass:"flex_display_centered_child"},[_c('i',{staticClass:"fas",class:{ 'fa-user': props.option.accountType === 'individual', 'fa-users': props.option.accountType !== 'individual' },attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"search_result_item_content"},[_c('div',{staticClass:"search_result_item_content_title"},[_c('a',{on:{"click":function($event){_vm.closeSearch()}}},[_vm._v(_vm._s(props.option.displayName))])]),_vm._v(" "),_c('div',{staticClass:"search_result_item_content_description"},[_vm._v(_vm._s(props.option.accountType))])])]):(!props.option.isGroup && props.option.type === 'Households')?_c('div',{staticClass:"search_result_item flex_display"},[_c('div',{staticClass:"flex_display search_result_item_icon"},[_c('div',{staticClass:"flex_display_centered_child"},[_c('i',{staticClass:"fas fa-home",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"search_result_item_content"},[_c('div',{staticClass:"search_result_item_content_title"},[_c('a',{on:{"click":function($event){_vm.closeSearch()}}},[_vm._v(_vm._s(props.option.householdName))])]),_vm._v(" "),_c('div',{staticClass:"search_result_item_content_description"},[_vm._v(_vm._s(props.option.householdDescription))])])]):(!props.option.isGroup && props.option.type === 'Campaigns')?_c('div',{staticClass:"search_result_item flex_display"},[_c('div',{staticClass:"flex_display search_result_item_icon"},[_c('div',{staticClass:"flex_display_centered_child"},[_c('i',{staticClass:"fas fa-bullhorn",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"search_result_item_content"},[_c('div',{staticClass:"search_result_item_content_title"},[_c('a',{on:{"click":function($event){_vm.closeSearch()}}},[_vm._v(_vm._s(props.option.campaignName))])]),_vm._v(" "),_c('div',{staticClass:"search_result_item_content_description"},[_vm._v(_vm._s(props.option.campaignDescription))])])]):(!props.option.isGroup && props.option.type === 'Events')?_c('div',{staticClass:"search_result_item flex_display"},[_c('div',{staticClass:"flex_display search_result_item_icon"},[_c('div',{staticClass:"flex_display_centered_child"},[_c('i',{staticClass:"fas fa-calendar",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"search_result_item_content"},[_c('div',{staticClass:"search_result_item_content_title"},[_c('a',{on:{"click":function($event){_vm.closeSearch()}}},[_vm._v(_vm._s(props.option.eventName))])]),_vm._v(" "),_c('div',{staticClass:"search_result_item_content_description"},[_vm._v(_vm._s(props.option.eventDescription))])])]):(!props.option.isGroup && props.option.type === 'showMore')?_c('div',{staticClass:"search_result_show_more flex_display"},[_c('a',{staticClass:"search_result_show_more_link div_aline_right",on:{"click":function($event){_vm.closeSearch()}}},[_vm._v("Show more ")])]):_vm._e()]}}])},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v("Oops! No elements found. Consider changing the search query.")])])],1)]),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('div',{staticClass:"div_aline_right flex_display",attrs:{"id":"tnRightActions"}},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"flex_display",attrs:{"id":"tnaIconBtns"}},[_c('b-dropdown',{staticClass:"bootstrap_button_dropdown flex_display_centered_child_vertical",attrs:{"right":"","variant":"link","no-caret":""}},[_c('template',{slot:"button-content"},[_c('div',{staticClass:"navigation_circle_style navigation_settings navigation_create_action flex_display"},[_c('span',[_c('i',{staticClass:"fas fa-plus-circle",attrs:{"aria-hidden":"true"}})])])]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("New Individual")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("New Organization")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("New Donation")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("New Event Registration")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("New Store Order")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("New Membership")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("New Pledge")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("New Activity")])],2),_vm._v(" "),_c('b-dropdown',{staticClass:"bootstrap_button_dropdown flex_display_centered_child_vertical",attrs:{"right":"","variant":"link","no-caret":""}},[_c('template',{slot:"button-content"},[_c('div',{staticClass:"navigation_circle_style navigation_settings flex_display"},[_c('span',[_c('i',{staticClass:"fas fa-cog",attrs:{"aria-hidden":"true"}})])])]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("System Settings Home")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("Organization Profile")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("2-Step Verification")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("User Groups/Permissions")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("System Users")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("Data Backup Utility")])],2)],1),_vm._v(" "),_c('div',{attrs:{"id":"tnaIconNotification"}},[_c('div',{staticClass:"navigation_circle_style navigation_settings flex_display",on:{"click":function($event){_vm.hidenc()}}},[_vm._m(8)]),_vm._v(" "),_c('div',{staticClass:"notification_shake_number navigation_circle_style flex_display shake",on:{"click":function($event){_vm.shakeit()}}},[_c('span',{staticClass:"navigation_notification_center_label"},[_vm._v("\n                  99\n                ")])])]),_vm._v(" "),_c('div',{attrs:{"id":"tnaVerticalLine"}}),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('div',{staticClass:"flex_display neon_dropdown",attrs:{"id":"tnaMyAccount"},on:{"click":function($event){_vm.toggleMyAccountMenu()}}},[_c('b-dropdown',{staticClass:"bootstrap_button_dropdown bootstrap_my_account",attrs:{"right":"","variant":"link","no-caret":"","toggle-class":"arrow_controller"}},[_c('template',{slot:"button-content"},[_c('div',{staticClass:"dropdown_arrow_small flex_display_centered_child"})]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("Sign-in & Security")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"neon_dropdown_item",attrs:{"href":"#"}},[_vm._v("Action Log")])],2)],1)])]),_vm._v(" "),_c('div',{staticClass:"flex_display",attrs:{"id":"tnMenu"}},[_c('div',{staticClass:"flex_display",attrs:{"id":"tnLeftMenu"}},[_vm._l((_vm.menus),function(menu){return (menu.id !== 999 && menu.show)?_c('div',{staticClass:"navigation_menu",class:{ menu_active: menu.isActive, menu_hide: !menu.isActive },attrs:{"id":menu.module},on:{"click":function($event){_vm.toggle(menu.module, $event)}}},[_c('div',{staticClass:"flex_display navigation_menu_label_container"},[_c('span',{staticClass:"navigation_menu_label flex_display_centered_child",class:{ has_submenu: menu.subMenu !== undefined && menu.subMenu !== null }},[_vm._v("\n                "+_vm._s(menu.displayName)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"flex_display notification_menu_expand_arrow"},[(menu.subMenu !== undefined && menu.subMenu !== null)?_c('div',{staticClass:"flex_display_centered_child flex_display",class:{ open: menu.isActive }},[_c('span',{staticClass:"notification_menu_expand_arrow_left"}),_vm._v(" "),_c('span',{staticClass:"notification_menu_expand_arrow_right"})]):_vm._e()])]),_vm._v(" "),(menu.isActive && menu.subMenu !== undefined && menu.subMenu !== null)?_c('div',{staticClass:"navigation_menu_arrow_container"},[_c('div',{staticClass:"navigation_menu_arrow flex_display_centered_child"})]):_vm._e(),_vm._v(" "),(menu.isActive && menu.subMenu !== undefined && menu.subMenu !== null)?_c('div',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.toggleClose),expression:"toggleClose"}],staticClass:"navigation_menu_panel flex_display",class:{ right_aligned: !menu.subMenu.menuLeftAlign }},[(menu.subMenu.iconMenus)?_c('div',{staticClass:"navigation_menu_panel_left flex_display"},[_c('div',{staticClass:"navigation_menu_panel_left_title"}),_vm._v(" "),_vm._l((menu.subMenu.iconMenus),function(iconMenu){return _c('div',{staticClass:"navigation_menu_icon"},[_c('div',{staticClass:"navigation_menu_icon_container flex_display"},[_c('div',{staticClass:"navigation_panel_circle_style flex_display flex_display_centered_child"},[_c('span',{staticClass:"navigation_panel_circle_style_label flex_display_centered_child"},[_c('i',{class:iconMenu.iconName,attrs:{"aria-hidden":"true"}})])])]),_vm._v(" "),_c('div',{staticClass:"navigation_menu_icon_label_container flex_display"},[_c('div',{staticClass:"navigation_menu_icon_label"},[_vm._v("\n                      "+_vm._s(iconMenu.displayName)+"\n                    ")])])])})],2):_vm._e()]):_vm._e()]):(menu.id === 999 && menu.show)?_c('div',{staticClass:"navigation_menu",class:{ menu_active: menu.isActive, menu_hide: !menu.isActive },attrs:{"id":menu.module}},[_c('div',{staticClass:"flex_display navigation_menu_label_container",on:{"click":function($event){_vm.toggle(menu.module, $event)}}},[_c('span',{staticClass:"navigation_menu_label flex_display_centered_child"},[_vm._v("\n                "+_vm._s(menu.displayName)+"\n              ")]),_vm._v(" "),(menu.subMenu !== undefined && menu.subMenu !== null)?_c('span',{staticClass:"dropdown_arrow_small flex_display_centered_child navigation_menu_dropdown_arrow",class:{ dropup_arrow: menu.isActive }}):_vm._e()]),_vm._v(" "),_vm._m(10),_vm._v(" "),(menu.isActive)?_c('div',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.toggleClose),expression:"toggleClose"}],staticClass:"navigation_menu_panel viewmore_menu flex_display"},[_c('div',{staticClass:"navigation_menu_panel_right"},[_c('div',{staticClass:"navigation_viewmore_menu_list"},[_c('ul',{staticClass:"viewmore_menu_main_menu"},_vm._l((_vm.menus),function(viewMoreMenu){return (viewMoreMenu.module !== 'viewmore' && !viewMoreMenu.show)?_c('li',{staticClass:"viewmore_menu_main_menu_item",class:{ viewmore_menu_active: viewMoreMenu.isActive, viewmore_menu_hide: !viewMoreMenu.isActive },attrs:{"id":viewMoreMenu.module + '_list'}},[(viewMoreMenu.subMenu !== undefined && viewMoreMenu.subMenu !== null)?_c('div',{staticClass:"viewmore_menu_main_menu_item_label flex_display",on:{"click":function($event){_vm.viewMoreMenuToggle(viewMoreMenu.module)}}},[_c('div',{staticClass:"viewmore_menu_main_menu_item_text div_aline_left"},[_vm._v("\n                          "+_vm._s(viewMoreMenu.displayName)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"flex_display notification_dropdown_menu_expand_arrow div_aline_right"},[(viewMoreMenu.subMenu !== undefined && viewMoreMenu.subMenu !== null)?_c('div',{staticClass:"flex_display_centered_child flex_display",class:{ open: viewMoreMenu.isActive }},[_c('span',{staticClass:"notification_dropdown_menu_expand_arrow_left"}),_vm._v(" "),_c('span',{staticClass:"notification_dropdown_menu_expand_arrow_right"})]):_vm._e()])]):_c('div',{staticClass:"viewmore_menu_main_menu_item_label flex_display"},[_c('div',{staticClass:"viewmore_menu_main_menu_item_text div_aline_left"},[_vm._v(_vm._s(viewMoreMenu.displayName))])]),_vm._v(" "),(viewMoreMenu.isActive && viewMoreMenu.subMenu !== undefined && viewMoreMenu.subMenu !== null)?_c('ul',{staticClass:"viewmore_menu_submenu"},_vm._l((viewMoreMenu.subMenu.iconMenus),function(viewMoreSubmenuMenu){return _c('li',{staticClass:"viewmore_menu_submenu_item"},[_c('div',{staticClass:"viewmore_submenu_item_container flex_display"},[_c('div',{staticClass:"viewmore_submenu_item_icon flex_display"},[_c('i',{staticClass:"flex_display_centered_child",class:viewMoreSubmenuMenu.iconName,attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"viewmore_submenu_item_label"},[_vm._v("\n                              "+_vm._s(viewMoreSubmenuMenu.displayName)+"\n                            ")])])])})):_vm._e()]):_vm._e()}))])])]):_vm._e()]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"navigation_menu invisible_menu",attrs:{"id":"invisibleMenu"}},[_vm._v("\n            Invisible for Length Calculate\n          ")])],2),_vm._v(" "),_c('div',{staticClass:"flex_display div_aline_right",attrs:{"id":"tnRightMenu"}},[_c('div',{staticClass:"navigation_menu_editor flex_display_centered_child"},[_c('div',{staticClass:"navigation_edit_pencil_container flex_display"},[_c('div',{staticClass:"navigation_circle_style navigation_edit_pencil flex_display flex_display_centered_child",on:{"click":function($event){_vm.toggleMenuEditor()}}},[_c('span',[(!_vm.editingMenu)?_c('i',{staticClass:"fas fa-pencil-alt",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(_vm.editingMenu)?_c('i',{staticClass:"fas fa-ban",attrs:{"aria-hidden":"true"}}):_vm._e()])])]),_vm._v(" "),(_vm.editingMenu)?_c('div',{staticClass:"navigation_menu_arrow_container navigation_menu_editor_arrow"},[_c('div',{staticClass:"navigation_menu_arrow flex_display_centered_child"})]):_vm._e(),_vm._v(" "),(_vm.editingMenu)?_c('div',{staticClass:"navigation_menu_panel navigation_menu_edit_panel"},[_c('div',{staticClass:"navigation_menu_edit_panel_header flex_display"},[_c('Span',[_vm._v("Navigation Order")])],1),_vm._v(" "),_c('ul',[_c('draggable',{attrs:{"options":{handle:'.drag_handle'}},on:{"start":_vm.startDrag,"end":_vm.endDrag}},_vm._l((_vm.menus),function(menucp2){return (menucp2.id !== 999)?_c('li',{key:menucp2.id,staticClass:"drag_list flex_display"},[_c('div',{staticClass:"drag_label"},[_vm._v("\n                      "+_vm._s(menucp2.displayName)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"drag_handel_container flex_display"},[_c('span',{staticClass:"drag_handle"})])]):_vm._e()}))],1),_vm._v(" "),_c('div',{staticClass:"navigation_menu_edit_panel_footer flex_display"},[_c('div',{staticClass:"navigation_menu_edit_panel_footer_left"},[_c('button',{staticClass:"footer_link neon_btn_sm neon_btn_link neon_button_link_normal",on:{"click":function($event){_vm.rollBackMenuChanges()}}},[_vm._v("\n                    Reset\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"navigation_menu_edit_panel_footer_right"},[_c('button',{staticClass:"footer_link neon_btn_sm neon_btn_primary neon_btn_default neon_button_link_submit",on:{"click":function($event){_vm.saveMenuChanges()}}},[_vm._v("\n                    Save\n                  ")])])])]):_vm._e()])])])])]),_vm._v(" "),_c('notificationCenter',{attrs:{"panelActive":_vm.notificationCenterActive},on:{"xoxoxox":_vm.hideDialog}}),_vm._v(" "),_c('transition',{attrs:{"name":"bounceLeft"}},[(_vm.miniMenu)?_c('div',{directives:[{name:"responsive",rawName:"v-responsive.sm.xs",modifiers:{"sm":true,"xs":true}}],attrs:{"id":"miniMenu"}},[_c('div',{staticClass:"mini_menu_header flex_display",attrs:{"id":"miniMenuHeader"}},[_c('div',{staticClass:"div_aline_left flex_display mini_my_account_container"},[_c('div',{staticClass:"div_aline_left",attrs:{"id":"miniTnInformation"}},[_c('div',{staticClass:"navigation_full_name"},[_vm._v("\n              Edward Nicholas Shen\n            ")]),_vm._v(" "),_c('div',{staticClass:"mini_navigation_logout"},[_c('a',{attrs:{"href":"#"}},[_vm._v("log out")])])]),_vm._v(" "),_c('div',{staticClass:"div_aline_right flex_display",attrs:{"id":"miniTnMyAccount"},on:{"click":function($event){_vm.miniMenuToggle('myAccount')}}},[_c('div',{staticClass:"dropdown_arrow_small flex_display_centered_child"})])]),_vm._v(" "),_c('div',{staticClass:"div_aline_right"},[_c('div',{staticClass:"icons"},[_c('div',{staticClass:"icon-box"},[_c('svg',{staticClass:"icon-close scale",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12"},on:{"click":_vm.toggleMiniMenu}},[_c('title',[_vm._v("Close")]),_c('polygon',{attrs:{"points":"12 1.4 10.6 0 6 4.6 1.4 0 0 1.4 4.6 6 0 10.6 1.4 12 6 7.4 10.6 12 12 10.6 7.4 6 12 1.4"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"mini_menu_content"},[(_vm.miniMyAccountMenu)?_c('div',{staticClass:"mini_my_account"},[_c('ul',{staticClass:"mini_menu_submenu mini_my_account_menu"},[_c('li',{staticClass:"mini_menu_submenu_item ",attrs:{"href":"#"}},[_vm._v("Sign-in & Security")]),_vm._v(" "),_c('li',{staticClass:"mini_menu_submenu_item",attrs:{"href":"#"}},[_vm._v("Action Log")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mini_menu_overflow_container"},[_c('ul',{staticClass:"mini_menu_main_menu"},_vm._l((_vm.menus),function(miniMenu){return (miniMenu.id !== 999 && miniMenu.show)?_c('li',{staticClass:"mini_menu_main_menu_item",class:{ mini_menu_active: miniMenu.isActive, mini_menu_hide: !miniMenu.isActive },attrs:{"id":'miniMenu_'+miniMenu.module}},[(miniMenu.subMenu !== undefined && miniMenu.subMenu !== null)?_c('div',{staticClass:"mini_menu_main_menu_item_label flex_display",on:{"click":function($event){_vm.miniMenuToggle(miniMenu.module)}}},[_c('div',{staticClass:"mini_menu_main_menu_item_text div_aline_left"},[_vm._v(_vm._s(miniMenu.displayName))]),_vm._v(" "),_c('div',{staticClass:"flex_display notification_dropdown_menu_expand_arrow div_aline_right"},[(miniMenu.subMenu !== undefined && miniMenu.subMenu !== null)?_c('div',{staticClass:"flex_display_centered_child flex_display",class:{ open: miniMenu.isActive }},[_c('span',{staticClass:"notification_dropdown_menu_expand_arrow_left"}),_vm._v(" "),_c('span',{staticClass:"notification_dropdown_menu_expand_arrow_right"})]):_vm._e()])]):_c('div',{staticClass:"mini_menu_main_menu_item_label flex_display"},[_c('div',{staticClass:"mini_menu_main_menu_item_text div_aline_left"},[_vm._v(_vm._s(miniMenu.displayName))])]),_vm._v(" "),(miniMenu.isActive && miniMenu.subMenu !== undefined && miniMenu.subMenu !== null)?_c('ul',{staticClass:"mini_menu_submenu"},_vm._l((miniMenu.subMenu.iconMenus),function(miniSubMenu){return _c('li',{staticClass:"mini_menu_submenu_item"},[_vm._v(_vm._s(miniSubMenu.displayName))])})):_vm._e()]):_vm._e()}))])])]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation_circle_style navigation_menu_bar flex_display transparent_bg navigation_mini_icon"},[_c('span',[_c('i',{staticClass:"fas fa-bars",attrs:{"aria-hidden":"true"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"miniTnLogo"}},[_c('img',{staticClass:"navigation_logo",attrs:{"src":__webpack_require__(19)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-search",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-bell",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mini_advanced_search_icon"},[_c('i',{staticClass:"fas fa-sliders-h",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tnaLogo"}},[_c('img',{staticClass:"navigation_logo",attrs:{"src":__webpack_require__(19)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tnaAdvancedSearchBox"}},[_c('span',{staticClass:"advanced_search_icon"},[_c('i',{staticClass:"fas fa-sliders-h",attrs:{"aria-hidden":"true"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tnaNewBtn"}},[_c('div',{staticClass:"navigation_create_action_container"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-bell",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tnaInformation"}},[_c('div',{staticClass:"navigation_full_name"},[_vm._v("\n              Edward Nicholas Shen\n            ")]),_vm._v(" "),_c('div',{staticClass:"navigation_logout"},[_c('a',{attrs:{"href":"#"}},[_vm._v("log out")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation_menu_arrow_container"},[_c('div',{staticClass:"navigation_menu_arrow flex_display_centered_child"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(20);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac6f6a98_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(67);
function injectStyle (ssrContext) {
  __webpack_require__(66)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac6f6a98_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 66:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"flex_display",attrs:{"id":"titanNavigationFooter"}},[_c('div',{staticClass:"footer_text flex_display_centered_child"},[_vm._v("NeonCRM Copyright © 2018 Z2 Systems, Inc. All rights reserved.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[498]);


// WEBPACK FOOTER //
// static/js/index.9c995906780b7faedbc6.js